import React from 'react';
import { Box, Typography } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';
import Button from '../components/common/Button';
import { ROUTES } from '../constants';

const NotFoundPage: React.FC = () => {
  return (
    <Box
      sx={{
        minHeight: '60vh',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        textAlign: 'center',
        px: 2
      }}
    >
      <Typography variant="h2" sx={{ mb: 1, fontWeight: 700 }}>
        404
      </Typography>
      <Typography variant="h5" sx={{ mb: 2 }}>
        Page not found
      </Typography>
      <Typography variant="body1" color="text.secondary" sx={{ mb: 4, maxWidth: 400 }}>
        The page you are looking for doesn&apos;t exist or has been moved.
      </Typography>
      <Button
        variant="contained"
        color="primary"
        component={RouterLink}
        to={ROUTES.HOME}
      >
        Back to Home
      </Button>
    </Box>
  );
};

export default NotFoundPage;
